<template>
  <div v-if="partnerCategories.length === 0" class="view-partners">
    <Container>
      <b-row align-v="center">
        <b-col md="5" lg="6">
          <h1>
            Our<br />
            Partners
          </h1>
        </b-col>
        <b-col class="fs20 mt-40 mt-md-0" v-html="bodyText">
          <!-- Want to partner with us? Please send<br /> an email to <a href="mailto:info@thehub.dk" class="text-blue-900">info@thehub.dk</a> ! -->
        </b-col>
      </b-row>
    </Container>
    <Container v-if="partners.length" background-color="#F5F7FA">
      <b-row>
        <b-col v-for="item in partners" :key="item.id" cols="6" md="4" lg="3">
          <a
            :href="item.websiteUrl"
            target="_blank"
            class="bg-white d-flex align-items-center justify-content-center mb-20 p-20"
            style="height:200px"
          >
            <img class="img-fluid" :src="item.logo.resizedUrl(300, 300)" alt="" />
          </a>
        </b-col>
      </b-row>
    </Container>
  </div>
  <div v-else class="view-partners">
    <div v-for="category in partnerCategories" :key="category._id" cols="6" md="4" lg="3">
      <Container>
        <b-row align-v="center">
          <b-col md="5" lg="6">
            <h1>
              {{ category.title }}<br />
              Partners
            </h1>
          </b-col>
          <b-col class="fs20 mt-40 mt-md-0">
            Want to feature The Hub's jobs on your website? Email us at
            <a href="mailto:info@thehub.dk" class="text-blue-900">info@thehub.dk</a>
          </b-col>
        </b-row>
      </Container>
      <Container
        v-if="
          partners.length && partners.filter((partner) => partner.categories.includes(category._id))
        "
        background-color="#F5F7FA"
      >
        <b-row>
          <b-col
            v-for="item in partners.filter((partner) => partner.categories.includes(category._id))"
            :key="item.id"
            cols="6"
            md="4"
            lg="3"
          >
            <a
              :href="item.websiteUrl"
              target="_blank"
              class="bg-white d-flex align-items-center justify-content-center mb-20 p-20"
              style="height:200px"
            >
              <img class="img-fluid" :src="item.logo.resizedUrl(300, 300)" alt="" />
            </a>
          </b-col>
        </b-row>
      </Container>
    </div>
  </div>
</template>

<script>
import Container from '@/components/Container';
import { buildMetaHead } from '@/helpers/meta';

export default {
  name: 'PagePartners',
  components: {
    Container
  },
  head() {
    return buildMetaHead({
      title: 'Partners',
      description:
        'The Hub partners with 100+ of global & local job platforms, Nordic accelerators, tech conferences, startup service providers and many more.',
      path: this.$route.path,
      imageUrl: process.env.BASE_URL + '/images/thehub_2022_partners.jpg'
    });
  },
  computed: {
    bodyText() {
      return this.$store.state.partners.bodyText;
    },
    partners() {
      return this.$store.state.partners.partners;
    },
    partnerCategories() {
      return this.$store.getters['meta/partnerCategories'] || [];
    }
  },
  asyncData({ store, error }) {
    try {
      return store.dispatch('partners/get');
    } catch (err) {
      error(err);
    }
  },
  created: async function() {
    // console.log('PARTNERS INIT', this.partnerCategories, this.partners)
  }
};
</script>

<style lang="scss" scoped>
.img-fluid {
  max-height: 100%;
  flex: 0 0 auto;
}
</style>
